module.exports = __webpack_public_path__ + "img/13-2.53000289.png";